<template>
  <!-- エラーページ -->
  <div class="err">

    <p class="error-text" v-html="$t('500', null, 'localeError')" />

    <btn @click="clickBackToTop()">
      <span v-html="$t('btn001', null, 'localeError')" />
    </btn>
    <btn @click="goToOfficialSite()">
      <span v-html="$t('btn.officialwebsite', null, 'localeCommon')" />
    </btn>
  </div>
</template>

<script>
import Btn from '@components/global/button.vue'

import localeError from '@locales/error'
import localeCommon from '@locales/common'

export default {
  name: 'err',
  $messages: { localeError, localeCommon },
  components: {
    Btn,
  },  
  methods: {
    clickBackToTop() {
      this.$router.push({ name: 'top' })
    },
    goToOfficialSite() {
      window.open('https://fire-emblem-heroes.com/', '_blank')
    },
  }
}
</script>

<style lang="scss" scoped>
.error-summary {
  position: relative;
  margin: 80px auto -20px;
  overflow: hidden;
  white-space: nowrap;
  text-indent: 100%;
  background-repeat: no-repeat;
  background-position: left top;
  &.-err500 {
    background-image: url(#{$img-path}err/txt_500.png);
    width: 133px;
    height: 60px;
  }
}

.error-text {
  width: 90%;
  margin: 60px auto 70px;
  font-size: 3rem;
  font-weight: 600;
  text-shadow: $ts-base;
  text-align: center;
}

.button {
  margin: 22px auto 0;
  width: 570px;
}
</style>
